/* Packages */
import React from 'react';
import RangeList from './RangeList';

export default function RangeListFilter({filter = {}, updateFilters, value, layout = 'row'}) {
	/* Constants */
	const {name, filterKey, minValues, maxValues} = filter;
	const minBounds = minValues[0];
	const maxBounds = maxValues[maxValues.length - 1];

	/* Render */
	return (
		<div className="row row--equalized gutters-2">
			<div className={layout === 'row' ? 'col-6' : 'col-12'}>
				{(value.min !== minBounds || value.max !== maxBounds) && (
					<input
						type="hidden"
						name={filterKey}
						value={`${value.min === '' ? minBounds : value.min};${
							value.max === '' ? maxBounds : value.max
						}`}
					/>
				)}
				<RangeList
					id={`${name}-Van`}
					className="custom-select"
					emptyValueLabel={`Van`}
					value={value.min}
					options={minValues}
					bounds={minBounds}
					formatType={filterKey}
					onChange={(value) => {
						updateFilters(value, 'min');
					}}
				/>
			</div>
			<div className={layout === 'row' ? 'col-6' : 'col-12'}>
				<RangeList
					id={`${name}-Tot`}
					className="custom-select"
					emptyValueLabel={`Tot`}
					value={value.max}
					options={maxValues}
					bounds={maxBounds}
					formatType={filterKey}
					onChange={(value) => {
						updateFilters(value, 'max');
					}}
				/>
			</div>
		</div>
	);
}
